import { memo, type FC } from 'react';
import { css, styled } from 'styled-components';

import { RibbonVariant } from '../types.ts';

interface RibbonBadgeProps {
  variant: RibbonVariant;
}

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 28px;
  height: 28px;
  overflow: hidden;
`;

const Ribbon = styled.div<{ $variant: RibbonVariant }>`
  font-weight: 700;
  font-size: 8px;
  line-height: 10px;
  transform: rotate(315deg) translateX(-25%) translateY(0);
  transform-origin: center;
  display: flex;
  justify-content: center;
  width: 44px;
  text-transform: uppercase;
  ${({ $variant }) =>
    $variant === RibbonVariant.NEW &&
    css`
      background-color: ${({ theme }) => theme.colors.positive10};
      color: ${({ theme }) => theme.colors.positive120};
    `}
  ${({ $variant }) =>
    $variant === RibbonVariant.BETA &&
    css`
      background-color: ${({ theme }) => theme.colors.link10};
      color: ${({ theme }) => theme.colors.link120};
    `}
  ${({ $variant }) =>
    $variant === RibbonVariant.LEGACY &&
    css`
      background-color: ${({ theme }) => theme.colors.warning10};
      color: ${({ theme }) => theme.colors.warning120};
    `}
`;

export const CornerBadge: FC<RibbonBadgeProps> = memo(function CornerBadge({ variant }) {
  return (
    <Wrapper>
      <Ribbon $variant={variant}>{variant}</Ribbon>
    </Wrapper>
  );
});
